const doc = [({"da":({"js":({"feedback_steps":({"give_feedback_here":"Her giver du feedback på andres svar"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;